import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CsIconModule } from '@components/icon';
import { ReportFeedbackSheetComponent } from './report-feedback-sheet.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CsIconModule,
  ],
  declarations: [ReportFeedbackSheetComponent],
  exports: [ReportFeedbackSheetComponent],
})
export class ReportFeedbackSheetModule { }
